import axiosJava from "@/api/config_java";


export default {
  /**
   * 创建付款
   * @param {number} amount 充值金额
   * @returns {Promise<{code:number;data:any;msg:string}>}
   */
  paymentIntentsCreate(amount){
    return axiosJava.get('/am/api/airwallex/paymentIntentsCreate',{
      params:{
        amount
      }
    })
  },

  /**
   * 空中云汇付款结果查询
   * @param intentId
   * @returns {Promise<{code:number;data:any;msg:string}>}
   */
  retrievePaymentIntent(intentId){
    return axiosJava.get('/am/api/airwallex/retrievePaymentIntent',{
      params:{
        intentId
      }
    })
  }
}